
import { ClientInfo } from "../types";
import { useQuery } from "@tanstack/react-query";
import { getClient } from "../actions/getClient";

const defaultClient: ClientInfo = {
  firstName: "",
  lastName: "",
  alias: "",
  email: "",
  phone: "",
  avatar: "",
};

export const useClientInfo = (clientUid: string) => {
  const { data: client, isLoading, isError } = useQuery({
    queryKey: ["client", clientUid],
    queryFn: () => getClient(clientUid),
    enabled: !!clientUid,
    initialData: defaultClient,
  }); 

  return {
    client,
    isLoading,
    isError,
  };
};
